import { getFramework } from '@/framework';
import { getReferenceLinesState } from '../states/reference-lines-state';
import { ReferenceLineHistoryType } from '../types';

export class ClearReferenceLines {
    constructor(private id: string) {}

    clear(pushHistory = true) {
        const old = getReferenceLinesState(this.id).referenceLines;

        getReferenceLinesState(this.id).setReferenceLines([]);

        // 写入历史记录
        if (pushHistory) {
            const framework = getFramework(this.id);
            framework.service.history.write({
                type: ReferenceLineHistoryType.CLEAR,
                data: {
                    item: old,
                },
            });
        }
    }
}
